import React, {FunctionComponent, useState, useEffect} from "react"

interface CheckboxProps {
	disabled?: boolean
	value: boolean
	title: string
	fieldId: string
	onSubmit: (val: string, fieldId: string) => void
}

const CheckBox: FunctionComponent<CheckboxProps> = ({disabled = false, value, title, fieldId, onSubmit}) => {
	const [selected, setSelected] = useState(value)

	useEffect(() => {
		setSelected(value)
	}, [value])

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		onSubmit(e.target.checked.toString(), fieldId)
	}

	return (
		<div className='event-checkbox-wrapper'>
			<label className='event-check-label' htmlFor={fieldId}>
				{title}
			</label>
			<input
				type='checkbox'
				id={fieldId}
				name={fieldId}
				value={fieldId}
				disabled={disabled}
				defaultChecked={selected}
				onChange={handleChange}
			/>
		</div>
	)
}

export default CheckBox
